// Dynamic styles based on theme - to be used with useThemedStyles.
// The one selector field look (pickers, search selectors, date fields): same
// fill, border, corners and text as TextInput, with a chevron on the right.
export const createPickerButtonStyles = ({ ui: { colors, radius, touch, type } }) => ({
	button: {
		flexDirection: 'row',
		paddingHorizontal: 14,
		paddingVertical: 6,
		minHeight: touch.min,
		alignItems: 'center',
		justifyContent: 'space-between',
		borderRadius: radius.card,
		borderWidth: 1,
		borderColor: colors.borderStrong,
		backgroundColor: colors.card,
	},
	// Inside a Card the card-coloured fill would vanish (design/fieldSurface.js).
	buttonOnCard: {
		backgroundColor: colors.canvas,
	},
	label: {
		...type.rowText,
		flex: 1,
		color: colors.text,
	},
	icon: {
		marginLeft: 8,
		color: colors.textSecondary,
	},
	// Keep the outline: disabledBg matches the card in Light.
	disabled: {
		backgroundColor: colors.disabledBg,
		borderColor: colors.borderStrong,
	},
	disabledLabel: {
		color: colors.disabledText,
	},
});
